import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on a Display Network site (mobile): brand row with the long
 * headline over one in-page hotel card with a CTA button. The hotel card is a
 * static placeholder; it is not a template field.
 */
@Component({
  selector: 'app-pmax-display-mobile-05',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './display-mobile-05.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-mobile-05.component.scss'
})
export class PmaxDisplayMobile05PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton text lines above and below the ad, as % widths. */
  readonly linesAbove = [100, 100, 100, 100, 100, 100, 100, 75];
  readonly linesBelow = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100];

  readonly hotel = { image: HOTELS + 'porec-old-town.jpg', title: 'Poreč Old Town Suites and Rooms', subtitle: 'Najbolja cijena' };

  get longHeadline(): string {
    return this.data.longHeadlines[0] || 'Your long headline appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
